import React, { useEffect } from "react";
import Seat from "./Seat";
import useStore from "../store/store";
// import { Button } from "@mui/material";
// import RefreshIcon from "@mui/icons-material/Refresh";
import { styled } from "@mui/material/styles";
import { getPublicIP } from "../hooks/PublicIP";

export default function OfficeTX({ user }) {
  const [seats, seatMapTX1, seatMapTX2, seatMapTX3, setOffice, refreshSeats, office] = useStore(
    (state) => [
      state.seats,
      state.seatMapTX1,
      state.seatMapTX2,
      state.seatMapTX3,
      state.setOffice,
      state.refreshSeats,
      state.office,
    ]
  );  

  useEffect(() => {
    setOffice("TX")
    refreshSeats();
    getIp();
  }, []);

  const getIp = async () => {
    const ip = await getPublicIP();
    // console.log("ip in OfficeNY: ", ip);
    return ip;
  };

  // const refresh = async () => {
  //   refreshSeats();
  // };

  let index = 0;
  return (
    <div style={{ minWidth: "680px" }}>
      <TopseatMap>
        {seatMapTX1.map((seatIndex, col) => (
          <Seat
            seatIndex={seatIndex}
            user={user}
            key={index++}
          />
        ))}
      </TopseatMap>
      <div style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "50px"
      }}>
      <MainseatMap>
        {seatMapTX2.map((cells, col) => {
          const lm = (col % 2) * 20;
          // console.log(col, lm);
          return (
            <MainSeatColumn
              sx={{
                // marginLeft: lm + "px",
              }}
              key={index++}
            >
              {cells.map((seatIndex) => (
                <Seat
                  seatIndex={seatIndex}
                  user={user}
                  key={index++}
                />
              ))}
            </MainSeatColumn>
          );
        })}
      </MainseatMap>
      <MainseatMap>
        {seatMapTX3.map((cells, col) => {
          const lm = (col % 2) * 20;
          // console.log(col, lm);
          return (
            <MainSeatColumn
              sx={{
                marginBottom: lm + "px",
              }}
              key={index++}
            >
              {cells.map((seatIndex) => (
                <Seat
                  seatIndex={seatIndex}
                  user={user}
                  key={index++}
                />
              ))}
            </MainSeatColumn>
          );
        })}
      </MainseatMap>   
      </div>   
    </div>
  );
}

const TopseatMap = styled("div")({
  display: "flex",
  flexDirection: "row",
  margin: "20px",
  // align-items: "center",
  justifyContent: "center",
  columnGap: "50px",
});

const MainseatMap = styled("div")({
  display: "flex",
  flexDirection: "column",
  margin: "1px",
  justifyContent: "center",
  alignItems: "center",
});

const MainSeatColumn = styled("div")({
  display: "flex",
  flexDirection: "row",
});

// const Bottom = styled("div")({
//   display: "flex",
//   flexDirection: "row",
//   justifyContent: "center",
// });
